import React from "react";

import { useModalContext } from "../../contexts/ModalContext/context";
import { Button } from "../../UI/Button";
import { MappingFormModal } from "../MappingFormModal";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";

interface IKineticIntegrationProps {
  id: string;
  l1Id: number;
  l2Id: number;
  roomsyncFloorPlan: string;
  instanceId: string;
  enabledAccess: string;
  mappingType: string;
  yearOfStudy: string;
  studentType: string;
  pathway: number;
  importFieldSelection?: "STUDENT_TYPE" | "PATHWAY_ID" | "BOTH" | "NONE";
}

export const IntegrationKineticEditButton: React.FC<IKineticIntegrationProps> = (props) => {
  const { setIsOpen } = useModalContext();

  const openModal = () => setIsOpen(true);

  // Convert Kinetic props to IIntegrationsKinetic format for the modal
  const mappedProps = {
    id: Number(props.id),
    l1Id: props.l1Id,
    l2Id: props.l2Id,
    l3Id: 0, // Kinetic doesn't use l3Id in the same way
    enableAccess: props.enabledAccess === "Yes",
    instanceId: props.instanceId,
    yearOfStudyId: props.yearOfStudy,
    studentType: props.studentType,
    pathwayId: props.pathway,
    networkMappingType: props.mappingType,
    importFieldSelection: props.importFieldSelection,
  };

  return (
    <>
      <ReadOnlyWrapper>
        <Button onClick={openModal}>Edit</Button>
      </ReadOnlyWrapper>
      <MappingFormModal defaultProps={mappedProps} isKinetic={true} />
    </>
  );
};
